<template>
  <div class="bottom_btn_container bgwhite1" :class="{ disabled, fixed, cancel }">
    <div class="btn">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'bottom-btn',
  props: {
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false },
    cancel: { type: Boolean, default: false }
  },
  created () {
  }
}
</script>

<style scoped lang="scss">
.bottom_btn_container {
  display: flex;
  justify-content: center;
  // padding: 15px 0;
  .btn {
    width: 100%;
    height: 100px;
    font-size: 28px;
    background: #f5222d;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &.fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  &.cancel {
    .btn {
      background-color: #fff;
      color: #323233;
      border: 1PX solid #ebedf0;
    }
  }
  &.disabled {
    .btn {
      background-color: #f89ba0;
      color: #f8f8f8;
    }
  }
}
</style>
